import React from 'react'
import Form from 'react-bootstrap/Form';

interface IDropDownQuestion {
  title: string
  onChange: () => void
  values: string[]
  selectedValue: string
}

const DropDownQuestion = ({title, onChange, values, selectedValue}:IDropDownQuestion) => {
  return (
    <>    
      <div className='__dd-question-style'>
        <h4>{title}</h4>
        <Form.Select onChange={onChange} aria-label={title} defaultValue={selectedValue} >
        <option disabled>Vælg et alternativ</option>
        {
          values.map( value => <option value={value} key={value}>{value[0].toUpperCase() + value.substring(1)}</option>)
        } 
        </Form.Select>
      </div>
    </>

  )
}

export default DropDownQuestion